// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1bddb44b","239":"027442b2","455":"182979df"}[chunkId] + ".chunk.js";
};